module.exports = __webpack_public_path__ + "media/coffee-preferences/whole_bean-3abff6f7.png";